// Global options
const defaults = {
    // Timer options
    delay: 100,
    delay_listener: 1,
    // Subscription settings
    id: null, // {{ product.id }}
    active: false, // {{ subscription_active }}
    subscription_id: null, // {{ subscription_id }}
    subscription_only: false, // {{ subscription_only }}
    select_subscription_first: false, // {{ select_subscription_first }}
    // Subscription interval settings
    default_purchase_type: 'autodeliver', // {{ default_purchase_type }}
    shipping_interval_unit_type: 'Days', // {{ shipping_interval_unit_type }}
    shipping_interval_frequency: 30, // {{ shipping_interval_frequency }}
    // Price settings
    shop_currency: 'USD',
    currency_prefix: '$', // {{ currency_prefix }}
    currency_suffix: '', // {{ currency_suffix }}
    discount_percentage: 0, // {{ discount_percentage }}
    // Widget translation
    label_onetime: 'One-time purchase', // {{ label_onetime }}
    label_autodeliver: 'Subscribe &amp; save', // {{ label_autodeliver }}
    label_deliver_every: 'Deliver every', // {{ label_deliver_every }}
    // Data mapping
    variant_to_duplicate: {}, // { {% for variant in product.variants %}{{ variant.id }}:'{{ variant.metafields.subscriptions.discount_variant_id }}',{% endfor %} }
    variant_to_price: {}, // { {% for variant in product.variants %}{{ variant.id }}:'{{ variant.price | money_without_currency }}',{% endfor %} }
    duplicate_to_price: {}, // { {% for variant in product.variants %}{{ variant.metafields.subscriptions.discount_variant_id }}: '{{ variant.metafields.subscriptions.discount_variant_price }}',{% endfor %} },
    // Features
    update_pricing: true,
    currency_conversion: true, // Only works if store supports currency conversion via the Currency plugin
    disable_ajax: false,
    price_limiter: 3, // defining the max number of price elements
    dom_step_limiter: 3, // defining the top limit of the bottom up search approach 
    // Element overwrites
    price_selector: null,
    form_selector: null,
    options_selector: null,
    debug: false,
};

export default defaults;


// WEBPACK FOOTER //
// ./_static/js/_config.js